import React from 'react';
import { Button } from 'reactstrap';
import {
  Link,
  withRouter,
  RouteComponentProps,
  matchPath,
  generatePath,
} from 'react-router-dom';

const NewPractitionerButton = (
  props: RouteComponentProps<{
    organizationId: string;
    practitionerId: string;
  }> & {
    loading?: boolean;
    className?: string;
  },
) => {
  const path = '/organization/:organizationId/newPractitioner';
  const match = matchPath<{ organizationId: string }>(props.location.pathname, {
    path: '/organization/:organizationId/practitioner',
  });
  const gPath = match ? generatePath(path, match.params) : undefined;
  return (
    <Button
      tag={Link}
      color="success"
      className={
        props.className ? `${props.className} text-center` : 'text-center'
      }
      to={gPath}
      disabled={!gPath || props.loading}>
      New Clinican
    </Button>
  );
};

export default withRouter(NewPractitionerButton);
